var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlineInfo = function SvgOutlineInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0EACBD",
    clipPath: "url(#outline-info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11C21.994 4.928 17.072.006 11 0m0 20.167A9.166 9.166 0 1 1 20.167 11 9.177 9.177 0 0 1 11 20.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.167h-.916a.917.917 0 0 0 0 1.833H11v5.5a.917.917 0 0 0 1.833 0V11c0-1.013-.82-1.834-1.833-1.834M11 7.334a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outline-info_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgOutlineInfo;